import { ref, computed } from "vue";
function useImageSupport({
  bypassClientCheck = false
}) {
  const avifSupport = ref(false);
  const webpSupport = ref(false);
  const avifChecked = ref(false);
  const webpChecked = ref(false);
  const checked = computed(() => avifChecked.value && webpChecked.value);
  if (bypassClientCheck || process.client) {
    const avifImage = new Image();
    avifImage.src = `data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=`;
    avifImage.onload = () => {
      avifChecked.value = true;
      avifSupport.value = true;
    };
    avifImage.onerror = () => {
      avifChecked.value = true;
    };
    const webpImage = new Image();
    webpImage.src = `data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==`;
    webpImage.onload = () => {
      webpChecked.value = true;
      webpSupport.value = webpImage.width > 0 && webpImage.height > 0;
    };
    webpImage.onerror = () => {
      webpChecked.value = true;
    };
  }
  return {
    webpSupport,
    avifSupport,
    checked
  };
}
export {
  useImageSupport
};
